import { render, staticRenderFns } from "./epub.vue?vue&type=template&id=71e5a16c&scoped=true&"
import script from "./epub.vue?vue&type=script&lang=js&"
export * from "./epub.vue?vue&type=script&lang=js&"
import style0 from "./epub.vue?vue&type=style&index=0&id=71e5a16c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e5a16c",
  null
  
)

export default component.exports